export enum TipoBaseCalculoEnum {

  IMPOSTO = "Imposto",
  FIXO = "Fixo",
  IMPOSTO_FIXO = "Imposto/fixo"
}
